(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
 var interval = setInterval(function() {
    var links = document.querySelectorAll('a.search-icon');
    for (var i = 0; i < links.length; i++) {
        if (links[i].getAttribute('target') === '_blank') {
            links[i].removeAttribute('target');
            console.log('LINKS:', links[i]);
            clearInterval(interval);
        }
   
    }
}, 100);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-with-filter"] && !Shopify.designMode) return;
  try {
    
  $('.filter-category').change(function() {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  $('.filter-tag').change(function() {
    var url = $(this).val();
    if (url) {
      console.log(url);
      window.location = url;
    }
    return false;
  });

  } catch(e) { console.error(e); }
})();
})();
